// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.audio-overlay_wrapper__owlG1 {
  position: absolute;
  z-index: -1;
  top: 0;
  left: 0;

  display: flex;
  align-items: center;
  justify-content: center;

  width: 100%;
  height: 100%;

  background-color: black;
}

.audio-overlay_picture__KVN6C {
  position: absolute;
  z-index: -1;
  top: 0;
  left: 0;

  display: block;

  width: 100%;
  height: 100%;

  background-color: black;
}

.audio-overlay_image__vDFG3 {
  width: 100%;
  height: 100%;

  object-fit: contain;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
}
`, "",{"version":3,"sources":["webpack://./src/components/audio-overlay/audio-overlay.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;EACX,MAAM;EACN,OAAO;;EAEP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;;EAEvB,WAAW;EACX,YAAY;;EAEZ,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,MAAM;EACN,OAAO;;EAEP,cAAc;;EAEd,WAAW;EACX,YAAY;;EAEZ,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;;EAEZ,mBAAmB;EACnB,4BAA4B;EAC5B,2BAA2B;EAC3B,sBAAsB;AACxB","sourcesContent":[".wrapper {\n  position: absolute;\n  z-index: -1;\n  top: 0;\n  left: 0;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  width: 100%;\n  height: 100%;\n\n  background-color: black;\n}\n\n.picture {\n  position: absolute;\n  z-index: -1;\n  top: 0;\n  left: 0;\n\n  display: block;\n\n  width: 100%;\n  height: 100%;\n\n  background-color: black;\n}\n\n.image {\n  width: 100%;\n  height: 100%;\n\n  object-fit: contain;\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: cover;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `audio-overlay_wrapper__owlG1`,
	"picture": `audio-overlay_picture__KVN6C`,
	"image": `audio-overlay_image__vDFG3`
};
export default ___CSS_LOADER_EXPORT___;
